import script from "./BottomGuidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomGuidePanel.vue?vue&type=script&setup=true&lang=js"

import "./BottomGuidePanel.vue?vue&type=style&index=0&id=a1e3be24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1e3be24"]])

export default __exports__